/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Verification_Link_InvalidInputs */

const en_verification_link_invalid = /** @type {(inputs: Verification_Link_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verification link is invalid. Please double check the link in the email and try again.`)
};

const id_verification_link_invalid = /** @type {(inputs: Verification_Link_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tautan verifikasi tidak valid. Silakan periksa kembali tautan di email dan coba lagi.`)
};

const ms_verification_link_invalid = /** @type {(inputs: Verification_Link_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pautan pengesahan tidak sah. Sila periksa pautan dalam emel dan cuba lagi.`)
};

const ca_verification_link_invalid = /** @type {(inputs: Verification_Link_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'enllaç de verificació no és vàlid. Si us plau, verifica l'enllaç al correu i torna-ho a provar.`)
};

const cs_verification_link_invalid = /** @type {(inputs: Verification_Link_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ověřovací odkaz je neplatný. Zkontrolujte prosím odkaz v emailu a zkuste to znovu.`)
};

const da_verification_link_invalid = /** @type {(inputs: Verification_Link_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekræftelseslinket er ugyldigt. Dobbelttjek venligst linket i e-mailen, og prøv igen.`)
};

const de_verification_link_invalid = /** @type {(inputs: Verification_Link_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Bestätigungslink ist ungültig. Bitte überprüfen Sie den Link in der E-Mail und versuchen Sie es erneut.`)
};

const et_verification_link_invalid = /** @type {(inputs: Verification_Link_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kinnituslink on vigane. Kontrollige e-kirjas olevat linki ja proovige uuesti.`)
};

const es_verification_link_invalid = /** @type {(inputs: Verification_Link_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El enlace de verificación no es válido. Por favor, verifica el enlace en el correo electrónico e inténtalo de nuevo.`)
};

const fr_verification_link_invalid = /** @type {(inputs: Verification_Link_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le lien de vérification est invalide. Veuillez vérifier de nouveau le lien dans l’e-mail et réessayez.`)
};

const hr_verification_link_invalid = /** @type {(inputs: Verification_Link_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veza za potvrdu je nevažeća. Molimo provjerite vezu u e-mailu i pokušajte ponovo.`)
};

const it_verification_link_invalid = /** @type {(inputs: Verification_Link_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il link di verifica non è valido. Verifica nuovamente il link nell'email e riprova.`)
};

const lv_verification_link_invalid = /** @type {(inputs: Verification_Link_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apstiprināšanas saite ir nederīga. Lūdzu, pārbaudiet saiti e-pastā un mēģiniet vēlreiz.`)
};

const lt_verification_link_invalid = /** @type {(inputs: Verification_Link_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Patvirtinimo nuoroda yra neteisinga. Patikrinkite nuorodą el. laiške ir bandykite dar kartą.`)
};

const hu_verification_link_invalid = /** @type {(inputs: Verification_Link_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az ellenőrző link érvénytelen. Kérjük, ellenőrizze az emailben található linket és próbálja újra.`)
};

const nl_verification_link_invalid = /** @type {(inputs: Verification_Link_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De verificatielink is ongeldig. Controleer de link in de e-mail en probeer het opnieuw.`)
};

const nb_verification_link_invalid = /** @type {(inputs: Verification_Link_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekreftelseslenken er ugyldig. Dobbeltsjekk lenken i e-posten og prøv igjen.`)
};

const pl_verification_link_invalid = /** @type {(inputs: Verification_Link_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link weryfikacyjny jest nieprawidłowy. Sprawdź ponownie link w e-mailu i spróbuj ponownie.`)
};

const pt_verification_link_invalid = /** @type {(inputs: Verification_Link_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O link de verificação é inválido. Por favor, verifique o link no e-mail e tente novamente.`)
};

const ro_verification_link_invalid = /** @type {(inputs: Verification_Link_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linkul de verificare este invalid. Vă rugăm să verificați din nou linkul din e-mail și să încercați din nou.`)
};

const sk_verification_link_invalid = /** @type {(inputs: Verification_Link_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overovací odkaz je neplatný. Skontrolujte prosím odkaz v e-maile a skúste to znova.`)
};

const sl_verification_link_invalid = /** @type {(inputs: Verification_Link_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preveritvena povezava je neveljavna. Preverite povezavo v e-pošti in poskusite znova.`)
};

const fi_verification_link_invalid = /** @type {(inputs: Verification_Link_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vahvistuslinkki on virheellinen. Tarkista sähköpostin linkki ja yritä uudelleen.`)
};

const sv_verification_link_invalid = /** @type {(inputs: Verification_Link_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifieringslänken är ogiltig. Vänligen dubbelkolla länken i e-posten och försök igen.`)
};

const vi_verification_link_invalid = /** @type {(inputs: Verification_Link_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liên kết xác minh không hợp lệ. Vui lòng kiểm tra lại liên kết trong email và thử lại.`)
};

const tr_verification_link_invalid = /** @type {(inputs: Verification_Link_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doğrulama bağlantısı geçersiz. Lütfen e-postadaki bağlantıyı tekrar kontrol edin ve yeniden deneyin.`)
};

const el_verification_link_invalid = /** @type {(inputs: Verification_Link_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ο σύνδεσμος επαλήθευσης δεν είναι έγκυρος. Παρακαλούμε ελέγξτε προσεκτικά τον σύνδεσμο στο email και δοκιμάστε ξανά.`)
};

const bg_verification_link_invalid = /** @type {(inputs: Verification_Link_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Връзката за потвърждение е невалидна. Моля, проверете внимателно връзката в имейла и опитайте отново.`)
};

const ru_verification_link_invalid = /** @type {(inputs: Verification_Link_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ссылка для подтверждения недействительна. Пожалуйста, проверьте ссылку в письме и повторите попытку.`)
};

const sr_verification_link_invalid = /** @type {(inputs: Verification_Link_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Веза за верификацију није важећа. Молимо вас да двапут проверите везу у имејлу и покушате поново.`)
};

const uk_verification_link_invalid = /** @type {(inputs: Verification_Link_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Посилання для підтвердження недійсне. Будь ласка, уважно перевірте посилання в електронному листі і спробуйте ще раз.`)
};

const ka_verification_link_invalid = /** @type {(inputs: Verification_Link_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ვერიფიკაციის ბმული არასწორია. გთხოვთ, გადაამოწმოთ ბმული მეილში და სცადოთ კვლავ.`)
};

const hi_verification_link_invalid = /** @type {(inputs: Verification_Link_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सत्यापन लिंक अमान्य है। कृपया ईमेल में लिंक को दोबारा जांचें और पुनः प्रयास करें।`)
};

const th_verification_link_invalid = /** @type {(inputs: Verification_Link_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ลิงก์ยืนยันไม่ถูกต้อง โปรดตรวจสอบลิงก์ในอีเมลแล้วลองอีกครั้ง`)
};

const ko_verification_link_invalid = /** @type {(inputs: Verification_Link_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`확인 링크가 유효하지 않습니다. 이메일의 링크를 다시 확인하고 시도해 주세요.`)
};

const zh_verification_link_invalid = /** @type {(inputs: Verification_Link_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`验证链接无效。请仔细检查电子邮件中的链接并重试。`)
};

const zh_tw_verification_link_invalid = /** @type {(inputs: Verification_Link_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`驗證連結無效。請再次檢查電子郵件中的連結並重新嘗試。`)
};

const ja_verification_link_invalid = /** @type {(inputs: Verification_Link_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`確認用リンクが無効です。メール内のリンクを再確認してもう一度お試しください。`)
};

/**
* | output |
* | --- |
* | "Verification link is invalid. Please double check the link in the email and try again." |
*
* @param {Verification_Link_InvalidInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const verification_link_invalid = /** @type {((inputs?: Verification_Link_InvalidInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Verification_Link_InvalidInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_verification_link_invalid(inputs)
	if (locale === "ms") return ms_verification_link_invalid(inputs)
	if (locale === "ca") return ca_verification_link_invalid(inputs)
	if (locale === "cs") return cs_verification_link_invalid(inputs)
	if (locale === "da") return da_verification_link_invalid(inputs)
	if (locale === "de") return de_verification_link_invalid(inputs)
	if (locale === "et") return et_verification_link_invalid(inputs)
	if (locale === "es") return es_verification_link_invalid(inputs)
	if (locale === "fr") return fr_verification_link_invalid(inputs)
	if (locale === "hr") return hr_verification_link_invalid(inputs)
	if (locale === "it") return it_verification_link_invalid(inputs)
	if (locale === "lv") return lv_verification_link_invalid(inputs)
	if (locale === "lt") return lt_verification_link_invalid(inputs)
	if (locale === "hu") return hu_verification_link_invalid(inputs)
	if (locale === "nl") return nl_verification_link_invalid(inputs)
	if (locale === "nb") return nb_verification_link_invalid(inputs)
	if (locale === "pl") return pl_verification_link_invalid(inputs)
	if (locale === "pt") return pt_verification_link_invalid(inputs)
	if (locale === "ro") return ro_verification_link_invalid(inputs)
	if (locale === "sk") return sk_verification_link_invalid(inputs)
	if (locale === "sl") return sl_verification_link_invalid(inputs)
	if (locale === "fi") return fi_verification_link_invalid(inputs)
	if (locale === "sv") return sv_verification_link_invalid(inputs)
	if (locale === "vi") return vi_verification_link_invalid(inputs)
	if (locale === "tr") return tr_verification_link_invalid(inputs)
	if (locale === "el") return el_verification_link_invalid(inputs)
	if (locale === "bg") return bg_verification_link_invalid(inputs)
	if (locale === "ru") return ru_verification_link_invalid(inputs)
	if (locale === "sr") return sr_verification_link_invalid(inputs)
	if (locale === "uk") return uk_verification_link_invalid(inputs)
	if (locale === "ka") return ka_verification_link_invalid(inputs)
	if (locale === "hi") return hi_verification_link_invalid(inputs)
	if (locale === "th") return th_verification_link_invalid(inputs)
	if (locale === "ko") return ko_verification_link_invalid(inputs)
	if (locale === "zh") return zh_verification_link_invalid(inputs)
	if (locale === "zh-tw") return zh_tw_verification_link_invalid(inputs)
	if (locale === "ja") return ja_verification_link_invalid(inputs)
	return en_verification_link_invalid(inputs)
});